module.exports = __webpack_public_path__ + "static/media/es.377c0285.svg";